import store from "@/store";
const unAutPageList = [
  "install-data-base",
  "404",
  "500",
  "sign-in",
  "password-reset",
  "sign-up",
];

const unAutPage = (routeName) => {
  if (routeName === null || routeName === undefined) {
    return false;
  } else {
    const value = unAutPageList.includes(routeName);
    return value === true ? true : false;
  }
};

const userGuard = (roleKey) => {
  if (roleKey !== undefined) {
    const user = store.getters["AuthModule/_getUser"];

    if (user.PermissionNames !== null) {
      return user.PermissionNames.some((i) => i === roleKey);
    } else {
      return true;
    }
  } else return true;
};

export { unAutPage, userGuard };
